import { render } from "./dropZonePlanilha.vue?vue&type=template&id=0d4eaaa1&scoped=true"
import script from "./dropZonePlanilha.vue?vue&type=script&lang=js"
export * from "./dropZonePlanilha.vue?vue&type=script&lang=js"

import "./dropZonePlanilha.vue?vue&type=style&index=0&id=0d4eaaa1&scoped=true&lang=scss"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4eaaa1"]])

export default __exports__